// The API caps a collection point's display name at 60 characters so it fits
// the customer checkout selector.
export const DISPLAY_NAME_MAX_LENGTH = 60;

// Trims what the shop owner typed. A blank name means "no name", which the API
// expects as null rather than "".
export const normaliseDisplayName = (raw: string): string | null => {
    const name = raw.trim();
    return name === "" ? null : name;
};
